<script setup lang="ts">
import { ref } from 'vue'
import { RouterView, useRoute } from 'vue-router'
import { Layout, CartModal } from '@/components'
import { useCode, useCart, useUser, useSearchForm } from '@/composables'

// Router
const route = useRoute()

// キャンペーンコード
const { code } = useCode()
code.init()

// カート
const { cart } = useCart()
cart.init()

// ユーザーフォーム
const { user } = useUser()
user.init()

// ユーザーフォーム
const { search } = useSearchForm()
search.init()

/** カートダイアログが開いているか否か */
const isOpen = ref(false)
</script>

<template>
  <Layout.Wrapper>
    <Layout.Header>
      <div class="bg-white border-b-2 border-solid border-[#EE7A00]">
        <div class="container mx-auto px-4 sm:px-0">
          <div class="flex flex-row items-center justify-between py-4">
            <router-link
              to="/"
              class="text-lg font-bold text-blue-600 transition duration-500 ease-in-out transform hover:underline underline-offset-2 decoration-2"
            >
              <img class="w-48 sm:w-80 sm:pr-0 pr-2 max-w-[230px]" src="@/assets/img/logo.png" alt="エイビ進学ナビ" />
            </router-link>
            <button
              class="flex items-center px-4 py-3 transition duration-300 ease-out transform bg-yellow-50 rounded-xl focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
              @click="isOpen = true"
              v-if="route.name !== 'confirm'"
            >
              <img class="w-8 sm:w-6 pr-2 sm:pr-0 mr-1 hidden sm:block" src="@/assets/icons/cart.svg" alt="" />
              <div class="flex flex-wrap items-baseline justify-center">
                <span class="text-gray-900 font-black mr-1">資料請求BOX</span>
                <span>
                  <span class="text-red-500 text-2xl font-black mr-1">{{ cart.list.length }}</span>
                  <span class="text-gray-900">校</span>
                </span>
              </div>
            </button>
            <CartModal v-model="isOpen" />
          </div>
        </div>
      </div>
    </Layout.Header>

    <Layout.Main>
      <RouterView v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </RouterView>
    </Layout.Main>

    <Layout.Footer>
      <div class="bg-blue-50">
        <div class="container mx-auto p-2 sm:p-6 text-center">
          <span class="text-gray-500">&copy;Eibi Tsushin All Right Reserved.</span>
        </div>
      </div>
    </Layout.Footer>
  </Layout.Wrapper>
</template>
